import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAzureDetailsData, FinOpsAzureResourcesDayMeasures } from "./finops-azure-resources.model";

@Injectable({
    providedIn: 'root'
})
export class FinOpsAzureResourcesService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService
    ) {
    }

    loadFinOpsAzureResourcesHistoricalData(date: string, granularity: string, subscription: string) {
        return this.httpClient.get<FinOpsAzureResourcesDayMeasures>(`${this.configService.config.apiUrl}/finops/azure/resources?date=${date}&granularity=${granularity}&subscription=${subscription}`)
    }

    loadFinOpsAzureResourcesMeasures(date: string, subscriptionId: string) {
        return this.httpClient.get<FinOpsAzureResourcesDayMeasures>(`${this.configService.config.apiUrl}/finops/azure/resources/measures?date=${date}&subscription=${subscriptionId}`)
    }

    loadFinOpsAzureResourceDetails(date: string, subscriptionId: string, resourceId: string) {
        return this.httpClient.get<FinOpsAzureDetailsData>(`${this.configService.config.apiUrl}/finops/azure/resources/details?date=${date}&subscription=${subscriptionId}&resource_id=${resourceId}`)
    }
}
